import { render, staticRenderFns } from "./CreateEconomicGroup.vue?vue&type=template&id=b5cd5caa"
import script from "./CreateEconomicGroup.vue?vue&type=script&lang=js"
export * from "./CreateEconomicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports